<template>
  <div class="customer-dimension">
    <div class="search">
      <el-form ref="searchForm" :model="searchForm" label-width="80px">
        <div class="row">
          <el-form-item label="仓库：" prop="warehouseId" class="customer-form">
            <el-select
              class="white"
              clearable
              v-model="searchForm.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期：" prop="date" class="customer-form">
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btn-form">
            <el-button class="btn-blue" @click="search">搜索</el-button>
            <el-button class="btn-white" @click="resetForm('searchForm')"
              >清空</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="table">
      <div class="title">项目总览</div>
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column label="科目明细" prop="name" show-overflow-tooltip>
          <template slot-scope="scope">
            <a
              :href="`#${scope.row.name}`"
              :class="scope.row.name === '合计' ? 'high-total' : 'high-name'"
              style="
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
              >{{ scope.row.name }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        >
          <template slot-scope="scope">
            <div
              style="
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
              :class="[
                scope.row.name === '合计' ? 'high-total' : '',
                item.prop === 'grossProfit' && scope.row['grossProfit'] < 0
                  ? 'high-red'
                  : '',
              ]"
            >
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="border-dashed"></div>
    </div>
    <div
      class="table details-table"
      v-for="(item, index) in detailsTableList"
      :key="index"
    >
      <div class="title" :id="item.title">{{ item.title }}</div>
      <el-table ref="table" :data="item.tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in detailsTableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        >
          <template slot-scope="scope">
            <div
              style="
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
              :class="[
                scope.row.name === '合计' ? 'high-total' : '',
                item.prop === 'grossProfit' && scope.row['grossProfit'] < 0
                  ? 'high-red'
                  : '',
              ]"
            >
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="back-top" v-if="isShowBackTop" @click="backTop">
      <img src="../../../../../assets/images/backTop.png" />
    </div>
  </div>
</template>

<script>
import DataReport from "models/data-report";
import Expenses from "models/expenses";
const expenses = new Expenses();
import { formatTimeToDate } from "common/js/util";
export default {

  data() {
    return {
      tableData: [],
      tableTitleList: [
        { label: "仓库", prop: "storageName", width: "" },
        { label: "收入", prop: "income", width: "" },
        { label: "支出", prop: "expenditure", width: "" },
        { label: "毛利", prop: "grossProfit", width: "" },
      ],
      detailsTableList: [],
      detailsTableTitleList: [
        { label: "项目", prop: "name", width: "" },
        { label: "收入", prop: "income", width: "" },
        { label: "支出", prop: "expenditure", width: "" },
        { label: "毛利", prop: "grossProfit", width: "" },
      ],
      warehouseList: [],
      searchForm: {
        warehouseId: "",
        date: this.timeDefault(),
      },
      selectDate: "",
      //日期选择范围在31天内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      isShowBackTop: false
    }
  },

  
  created() {
    this.getWarehouseList();
    this.initList();
    this.initDetailsList();
  },
  // window对象，所有浏览器都支持window对象。它表示浏览器窗口，监听滚动事件
  mounted () {
    document.getElementById('pageContent').addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    document.getElementById('pageContent').removeEventListener('scroll', this.scrollToTop)
  },

  methods: {
    //获取仓库数据
    getWarehouseList() {
      expenses.getWarehouseData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },

    /* 客户总览  */
    initList() {
      let warehouseId = this.searchForm.warehouseId;
      let beginDate = this.searchForm.date[0]
      let endDate = this.searchForm.date[1]
      let data = {
        warehouseId,
        beginDate,
        endDate
      };

      DataReport.getCustomersOverviewList(data).then(res => {
        if (res.success) {
          let arr = [];
          res.result.projectOverviewEntityList.map((i) => {
            let obj = {};
            obj.projectId = i.projectId;
            obj.name = i.projectName;
            obj.storageName = i.warehouseName;
            obj.income = i.income;
            obj.expenditure = i.cost;
            obj.grossProfit = i.grossProfit;
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    },

    // 细项列表
    initDetailsList() {
      let warehouseId = this.searchForm.warehouseId;
      let beginDate = this.searchForm.date[0]
      let endDate = this.searchForm.date[1]
      let data = {
        warehouseId,
        beginDate,
        endDate
      };

      DataReport.getCustomersDetailsList(data).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.title = i.title;
            obj.tableData = []
            i.itemDetailEntityList.map(v => {
              let obj2 = {}
              obj2.name = v.itemName;
              obj2.income = v.income;
              obj2.expenditure = v.cost;
              obj2.grossProfit = v.grossProfit;
              obj.tableData.push(obj2)
            })
            arr.push(obj);
          });
          this.detailsTableList = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    },
    
    timeDefault() {
      let date = new Date();
      const yesterday = formatTimeToDate(date.getTime() - 86400000)
      const firstDate = formatTimeToDate(date.setDate(1))
      let arr = [firstDate, yesterday]
      if (new Date().getDate() === 1)  arr = [firstDate, firstDate]
      return arr;
    },

    search() {
      if (!this.searchForm.date) {
        return this.$message.error('请先选择日期')
      }
      this.currentPage = 1;
      this.initList();
      this.initDetailsList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop () {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.getElementById('pageContent').scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },

    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      const that = this
      let scrollTop = document.getElementById('pageContent').pageYOffset || document.getElementById('pageContent').scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 120) {
        that.isShowBackTop = true
      } else {
        that.isShowBackTop = false
      }
    }
  }
}
</script>

<style lang='scss'>
.customer-dimension {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  .search {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    height: 72px;
    .el-form {
      .el-form-item {
        .el-date-editor {
          width: 240px;
        }
      }
      .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .customer-form {
        .el-form-item__label {
          width: 50px !important;
        }
        .el-form-item__content {
          margin-left: 50px !important;
        }
      }
      .btn-form {
        .el-form-item__label {
          width: 20px !important;
        }
        .el-form-item__content {
          margin-left: 20px !important;
        }
      }
    }
    @media screen and (max-width: 900px) {
      .el-form {
        .el-form-item .el-form-item__label {
          line-height: 40px;
        }
        .el-input__inner {
          line-height: 27px;
        }
        .el-date-editor .el-range-input {
          line-height: 21px;
        }
        .btn-form {
          margin-bottom: 24px;
        } 
      }
    }
    @media screen and (max-width: 600px) {
      .el-form {
        .el-form-item .el-form-item__label {
          line-height: 41px;
        }
        .el-input__inner {
          line-height: 27px;
        }
        .el-date-editor .el-range-input {
          height: 28px;
          line-height: 27px;
        }
        .el-date-editor .el-input__icon {
          height: 24px;
          line-height: 24px;
        }
        .btn-form {
          margin-bottom: 22px;
        } 
      }
    }
  }

  .table {
    padding: 20px;
    .title {
      border-left: 3px solid #2e68ea;
      padding-left: 7px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 12px;
    }
    .high-name {
      display: inline-block;
      width: 100%;
      color: #2e68ea;
      font-size: 14px;
      cursor: pointer;
    }
    .high-total {
      font-weight: 500;
      color: #333333;
      font-size: 14px;
    }
    .high-red {
      font-size: 14px;
      color: #f55545;
    }
  }
  .border-dashed {
    margin-top: 20px;
    border-bottom: 1px dashed #BFBFBF;
  }
  .details-table {
    padding-top: 0px;
  }
  .back-top {
    width: 79px;
    height: 79px;
    position: fixed;
    bottom: 100px;
    right: 50px;
    z-index: 10;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
